import type { RubricDraft } from '../types/rubricDraft';
import { normalizeRubricDraft } from '../types/rubricDraft';

const LEGACY_KEY = 'sala_course_rubrics';
let storageOwnerUid: string | null = null;

export function setRubricStorageOwner(uid: string | null): void {
  storageOwnerUid = uid;
}

function storageKey(): string {
  return storageOwnerUid ? `sala_course_rubrics_${storageOwnerUid}` : LEGACY_KEY;
}

function canUseStorage(): boolean {
  return typeof localStorage !== 'undefined';
}

function readAll(): RubricDraft[] {
  if (!canUseStorage()) return [];
  try {
    const raw = localStorage.getItem(storageKey());
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RubricDraft[];
    return Array.isArray(parsed) ? parsed.map(normalizeRubricDraft) : [];
  } catch {
    return [];
  }
}

function writeAll(rubrics: RubricDraft[]): void {
  if (!canUseStorage()) return;
  localStorage.setItem(storageKey(), JSON.stringify(rubrics));
}

export function createRubricId(): string {
  return `rubric_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

export function listRubricsForCourse(courseId: string): RubricDraft[] {
  return readAll()
    .filter((rubric) => rubric.courseId === courseId)
    .sort((a, b) => b.updatedAt - a.updatedAt);
}

export function getRubric(id: string): RubricDraft | null {
  const found = readAll().find((rubric) => rubric.id === id) ?? null;
  return found ? normalizeRubricDraft(found) : null;
}

export function saveRubric(rubric: RubricDraft): RubricDraft {
  const all = readAll();
  const now = Date.now();
  const saved = normalizeRubricDraft({
    ...rubric,
    updatedAt: now,
    createdAt: rubric.createdAt || now,
  });
  const idx = all.findIndex((item) => item.id === saved.id);
  if (idx >= 0) all[idx] = saved;
  else all.push(saved);
  writeAll(all);
  return saved;
}

export function deleteRubric(id: string): void {
  writeAll(readAll().filter((rubric) => rubric.id !== id));
}
